// ===== Hero scene wiring you already have =====
export function sceneHeroCardboard() {
  // arrow wiggle
  gsap.to(".jr__hero-top__arrow", {
    y: 20,
    duration: 1,
    repeat: -1,
    yoyo: true,
    ease: "power1.inOut",
  });

  // bottle loop stays as before
  loopBottleRotation({ fps: 0.4 });

  // // crown sequence → play once when visible (and age-verified)
  // initCrownOnView({
  //   selector: "#crown-seq", // <image id="crown-seq"> inside your SVG
  //   trigger: ".jr__hero-top__stage", // element to watch for visibility
  //   totalFrames: 50, // 00..49
  //   fps: 36, // playback speed
  //   start: "top 80%", // ScrollTrigger start (if present)
  // });
}

function loopBottleRotation({ fps = 12 } = {}) {
  const imageCount = 120;
  const bottles = document.querySelectorAll(".jr__hero-top__bottle");
  if (!bottles.length) return;

  const imagePath = (i) => `/uploads/images/3d/jr-dark/${String(i).padStart(2, "0")}.webp`;
  const frames = Array.from({ length: imageCount }, (_, i) => {
    const im = new Image();
    im.src = imagePath(i);
    return im;
  });

  let acc = 0,
    currentIndex = -1,
    pendingIdx = -1;
  const render = (idx) => bottles.forEach((img) => frames[idx] && (img.src = frames[idx].src));

  (function rafLoop() {
    if (pendingIdx !== -1 && pendingIdx !== currentIndex) {
      currentIndex = pendingIdx;
      render(currentIndex);
    }
    requestAnimationFrame(rafLoop);
  })();

  gsap.ticker.add(() => {
    acc += fps * gsap.ticker.deltaRatio();
    if (acc >= imageCount) acc = acc % imageCount;
    const idx = acc | 0;
    if (idx !== currentIndex) pendingIdx = idx;
  });
}

// ===== Crown image-sequence: play once when section is visible (after age gate) =====
// export function initCrownOnView() {
//   (function () {
//     const XLINK = "http://www.w3.org/1999/xlink";
//     const stateMap = new WeakMap(); // element -> { started, rafId, trigger, queued }

//     function pad2(n) {
//       return String(n).padStart(2, "0");
//     }
//     const prefersReduced = typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches;

//     function setHref(node, url) {
//       node.setAttribute("href", url); // SVG2
//       node.setAttributeNS(XLINK, "xlink:href", url); // old Safari/WebKit
//     }

//     function hasAge() {
//       return document.cookie.includes("age-verification-yes=true") || window.__ageVerifiedOnce === true;
//     }

//     // Call this from your scene: initCrownOnView({ selector, trigger, totalFrames, fps, start })
//     window.initCrownOnView = function initCrownOnView({
//       selector = "#crown-seq",
//       trigger = ".jr__hero-top__stage",
//       totalFrames = 50,
//       fps = 36,
//       start = "top 80%",
//     } = {}) {
//       const img = document.querySelector(selector);
//       const host = document.querySelector(trigger);
//       if (!img || !host) return;

//       // idempotent: bail if already bound
//       if (stateMap.has(img)) return;
//       const st = { started: false, rafId: null, trigger: null, queued: false };
//       stateMap.set(img, st);

//       const srcFor = (i) => `/custom/images/animations-image-seq/crown/${pad2(i)}.webp`;

//       function cleanup() {
//         if (st.trigger && window.gsap && gsap.ScrollTrigger) {
//           st.trigger.kill();
//         }
//         st.trigger = null;
//       }

//       function playOnce() {
//         if (st.started) return;
//         st.started = true;

//         cleanup(); // ensure no future re-triggers
//         if (prefersReduced) {
//           setHref(img, srcFor(totalFrames - 1));
//           return;
//         }

//         const frameDuration = 1000 / Math.max(1, Number(fps) || 24);
//         let frame = 0;
//         let last = performance.now();

//         setHref(img, srcFor(0));

//         function tick(now) {
//           const elapsed = now - last;
//           if (elapsed >= frameDuration) {
//             const steps = Math.max(1, Math.floor(elapsed / frameDuration));
//             frame += steps;
//             last = now;
//             if (frame >= totalFrames) {
//               setHref(img, srcFor(totalFrames - 1)); // hold final frame
//               st.rafId = null;
//               return;
//             }
//             setHref(img, srcFor(frame));
//           }
//           st.rafId = requestAnimationFrame(tick);
//         }
//         st.rafId = requestAnimationFrame(tick);
//       }

//       // Guarded starter: coalesce multiple triggers in the same frame
//       function startOnceGuarded() {
//         if (st.started) return;
//         if (!hasAge()) return;
//         if (st.queued) return;
//         st.queued = true;
//         requestAnimationFrame(() => {
//           st.queued = false;
//           if (!st.started) playOnce();
//         });
//       }

//       // Visibility trigger
//       if (window.gsap && gsap.ScrollTrigger) {
//         gsap.registerPlugin(gsap.ScrollTrigger);
//         st.trigger = gsap.ScrollTrigger.create({
//           trigger: host,
//           start,
//           once: true, // auto-kill after first enter
//           onEnter: startOnceGuarded,
//         });
//       } else if ("IntersectionObserver" in window) {
//         const io = new IntersectionObserver(
//           (entries) => {
//             entries.forEach((e) => {
//               if (e.isIntersecting) {
//                 io.disconnect();
//                 startOnceGuarded();
//               }
//             });
//           },
//           { threshold: 0.2 }
//         );
//         io.observe(host);
//       } else {
//         // very old fallback
//         const kick = () => setTimeout(startOnceGuarded, 300);
//         document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", kick, { once: true }) : kick();
//       }

//       // Age gate events — still deduped
//       const markAge = () => {
//         window.__ageVerifiedOnce = true;
//         startOnceGuarded();
//       };
//       window.addEventListener("age:verified", markAge, { once: true });
//       window.addEventListener("ageVerification:accept", markAge, { once: true });

//       // Optional: if your app fires layout/ScrollTrigger refreshes, this prevents replays
//       window.addEventListener("layout:changed", () => cleanup());
//     };
//   })();
// }

// Optional runtime control (e.g., tweak speed before playing)
window.crownAnim = {
  setFps(n) {
    // You can re-init with a different fps by calling initCrownOnView again if needed.
    // This shim is here to keep your previous API shape.
    console.warn("To change FPS, re-call initCrownOnView({ fps: ... }) before it starts.");
  },
};

// code before updating for videos
// ===============================
// ===============================
// ===============================
// ===============================
// ===============================
// ===============================
// ===============================

// import { wireVideoFallback } from "../common/wireVideoFallback";
// import { hardPrime } from "../common/hardPrimeVideo";

// // --- tiny helper reused below ---
// async function awaitFirstFrame(video) {
//   if (!video) return;
//   if ("requestVideoFrameCallback" in video) {
//     await new Promise((res) => video.requestVideoFrameCallback(() => res()));
//     return;
//   }
//   if (video.readyState >= 2) return;
//   await new Promise((res) => {
//     const on = () => {
//       video.removeEventListener("loadeddata", on);
//       video.removeEventListener("canplay", on);
//       res();
//     };
//     video.addEventListener("loadeddata", on, { once: true });
//     video.addEventListener("canplay", on, { once: true });
//     try {
//       video.load();
//     } catch {}
//   });
// }

// export function sceneHeroCardboard() {
//   // arrow wiggle
//   gsap.to(".jr__hero-top__arrow", {
//     y: 20,
//     duration: 1,
//     repeat: -1,
//     yoyo: true,
//     ease: "power1.inOut",
//   });

//   // bottle loop stays as you had it
//   loopBottleRotation({ fps: 0.4 });

//   // --- SAFARI overlay fixer (unchanged except: NO autoplay on created <video>) ---
//   (function () {
//     // 1) Per-scene constants (match your markup)
//     const CONFIG = {
//       desktop: {
//         vb: { w: 1920, h: 1357 },
//         fo: { x: 275, y: 464, w: 555, h: 530 },
//       },
//       mobile: {
//         vb: { w: 1080, h: 1920 },
//         fo: { x: -25, y: 100, w: 680, h: 650 },
//       },
//     };

//     const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//     function getActiveScene() {
//       const desk = document.querySelector(".jr__hero-top__stage--desktop");
//       const mob = document.querySelector(".jr__hero-top__stage--mobile");
//       const deskShown = desk && getComputedStyle(desk).display !== "none";
//       const mobShown = mob && getComputedStyle(mob).display !== "none";
//       return mobShown ? { svg: mob, key: "mobile" } : deskShown ? { svg: desk, key: "desktop" } : null;
//     }

//     function rectsAlmostEqual(a, b, eps = 2) {
//       return Math.abs(a.left - b.left) < eps && Math.abs(a.top - b.top) < eps && Math.abs(a.width - b.width) < eps && Math.abs(a.height - b.height) < eps;
//     }

//     function expectedPxRect(svgEl, vb, r) {
//       const svgBox = svgEl.getBoundingClientRect();
//       const W = svgBox.width,
//         H = svgBox.height;
//       // preserveAspectRatio="xMidYMid slice"
//       const scale = Math.max(W / vb.w, H / vb.h);
//       const offsetX = (W - vb.w * scale) / 2;
//       const offsetY = (H - vb.h * scale) / 2;
//       return {
//         left: svgBox.left + offsetX + r.x * scale,
//         top: svgBox.top + offsetY + r.y * scale,
//         width: r.w * scale,
//         height: r.h * scale,
//       };
//     }

//     function ensureOverlay() {
//       const scene = getActiveScene();
//       if (!scene) return;
//       const { svg, key } = scene;
//       const { vb, fo } = CONFIG[key];

//       // Need overlay on Safari or if <foreignObject> is mispositioned
//       let needFallback = isSafari;
//       if (!needFallback) {
//         const foEl = svg.querySelector("foreignObject");
//         if (foEl) {
//           const want = expectedPxRect(svg, vb, fo);
//           const got = foEl.getBoundingClientRect();
//           if (!rectsAlmostEqual(want, got)) needFallback = true;
//         }
//       }

//       const host = svg.parentElement; // .jr__hero-top (position:relative)
//       const foVid = svg.querySelector("foreignObject video.jr__hero-top__video");
//       let overlay = host.querySelector(".jr__hero-top__htmlvideo");

//       if (!needFallback) {
//         // show FO video, remove overlay if it exists
//         if (foVid) foVid.style.display = "";
//         if (overlay) {
//           overlay.remove();
//           overlay = null;
//         }
//         return;
//       }

//       // needFallback: hide FO video, ensure overlay exists
//       if (foVid) foVid.style.display = "none";
//       if (!overlay) {
//         overlay = document.createElement("video");
//         overlay.className = "jr__hero-top__htmlvideo";
//         overlay.autoplay = false;
//         overlay.muted = true;
//         overlay.setAttribute("muted", "");
//         overlay.playsInline = true;
//         overlay.setAttribute("playsinline", "");
//         overlay.setAttribute("webkit-playsinline", "");
//         overlay.preload = "auto";
//         const s = document.createElement("source");
//         s.src = "/custom/images/webm/crown-new-sm-2s-safari.mov";
//         s.type = 'video/mp4; codecs="hvc1"';
//         overlay.appendChild(s);
//         Object.assign(overlay.style, {
//           position: "absolute",
//           pointerEvents: "none",
//           objectFit: "contain",
//           zIndex: "2",
//         });
//         host.style.position = host.style.position || "relative";
//         host.appendChild(overlay);
//       }

//       function layout() {
//         const want = expectedPxRect(svg, vb, fo);
//         const hostBox = host.getBoundingClientRect();
//         Object.assign(overlay.style, {
//           left: want.left - hostBox.left + "px",
//           top: want.top - hostBox.top + "px",
//           width: want.width + "px",
//           height: want.height + "px",
//         });
//       }
//       layout();
//       window.addEventListener("resize", layout);
//       window.addEventListener("orientationchange", layout);
//     }

//     if (document.readyState === "loading") {
//       document.addEventListener("DOMContentLoaded", ensureOverlay);
//     } else {
//       ensureOverlay();
//     }
//   })();

//   // Now hand control to autoplay-orchestrator (below)
//   init_hero_top_autoplay();
// }

// /* ──────────────────────────────────────────────────────────────
//    Below is the replacement autoplay orchestrator.
//    It force-disables markup autoplay, waits for images, then plays.
//    ────────────────────────────────────────────────────────────── */

// function sanitizeAutoplay() {
//   document.querySelectorAll(".jr__hero-top video").forEach((v) => {
//     try {
//       v.pause?.();
//     } catch {}
//     v.autoplay = false;
//     v.removeAttribute("autoplay");
//     // keep muted/inline so programmatic play later is allowed
//     v.muted = true;
//     v.setAttribute("muted", "");
//     v.playsInline = true;
//     v.setAttribute("playsinline", "");
//     v.setAttribute("webkit-playsinline", "");
//     // light preload until we’re ready
//     if (!v.getAttribute("preload")) v.preload = "auto";
//   });
// }

// function pickActiveVideo(container) {
//   const candidates = container.querySelectorAll(".jr__hero-top__video, .jr__hero-top__htmlvideo");
//   for (const v of candidates) {
//     const st = getComputedStyle(v);
//     if (st.display !== "none" && v.offsetWidth > 0 && v.offsetHeight > 0) return v;
//   }
//   return candidates[0] || null;
// }

// function getSceneParts(scene) {
//   if (!scene) return null;
//   const container = scene.closest(".jr__hero-top") || scene.parentElement || document;
//   const baseImage = scene.querySelector("image");
//   const bottleImg = scene.querySelector(".jr__hero-top__bottle");
//   const video = pickActiveVideo(container);
//   const fallback = video?.querySelector("img") || null;
//   return { baseImage, bottleImg, video, fallback, container };
// }

// function preloadSvgImageHref(el) {
//   const src = el?.getAttribute("href") || el?.getAttribute("xlink:href");
//   if (!src) return Promise.resolve();
//   return new Promise((res) => {
//     const im = new Image();
//     im.decoding = "async";
//     im.onload = () => res();
//     im.onerror = () => res(); // don’t block forever
//     im.src = src;
//   });
// }

// async function decodeImg(img) {
//   if (!img) return;
//   try {
//     if (img.decode) {
//       await img.decode();
//     } else if (!img.complete) {
//       await new Promise((res) => {
//         img.addEventListener("load", res, { once: true });
//         img.addEventListener("error", res, { once: true });
//       });
//     }
//   } catch {}
// }

// async function primeAndPlay(video) {
//   if (!video) return;
//   // "prime" (sets muted/autoplay attrs and inline flags)
//   hardPrime(video);
//   try {
//     await video.play();
//   } catch {}

//   await awaitFirstFrame(video).catch(() => {});
// }

// function init_hero_top_autoplay() {
//   const root = document.querySelector(".jr__hero-top");
//   if (!root) return;

//   // Immediately neuter any markup autoplay (this is why commenting the old
//   // function had no visible effect before)
//   sanitizeAutoplay();

//   const isRM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
//   const dScene = root.querySelector(".jr__hero-top__stage--desktop");
//   const mScene = root.querySelector(".jr__hero-top__stage--mobile");
//   const mq = window.matchMedia("(max-width: 900px)");

//   const state = new WeakMap();

//   async function readyScene(scene) {
//     if (!scene) return;
//     const s = state.get(scene) || { primed: false, playedOnce: false, io: null };
//     state.set(scene, s);

//     const { baseImage, bottleImg, video, fallback } = getSceneParts(scene);
//     if (!video) return;

//     if (!s.primed) {
//       if (fallback) wireVideoFallback(video, fallback);
//       // don’t set autoplay yet; we’ll let hardPrime do it right before play
//       s.primed = true;
//     }

//     if (isRM) return; // respect reduced motion

//     await Promise.all([preloadSvgImageHref(baseImage), decodeImg(bottleImg)]).catch(() => {});

//     // once images are ready, kick off the video
//     // prime once
//     hardPrime(video);

//     // prepare styles
//     video.style.opacity = "1"; // we want it visible, but paused on frame 0
//     if (fallback) fallback.style.display = ""; // keep fallback for safety

//     try {
//       // jump to frame 0 and paint it
//       video.currentTime = 0;
//       await awaitFirstFrame(video).catch(() => {});
//       // hide fallback now that the video has painted its first frame
//       if (fallback) fallback.style.display = "none";
//       // pause on that first frame
//       video.pause();
//     } catch {
//       /* ignore */
//     }

//     // after 1s: play from the painted frame
//     setTimeout(async () => {
//       try {
//         console.log("playing video");
//         await video.play();
//       } catch {}
//       s.playedOnce = true;
//     }, 300);
//   }

//   function pauseScene(scene) {
//     const { video } = getSceneParts(scene) || {};
//     try {
//       video?.pause?.();
//     } catch {}
//   }

//   function attachIO(scene) {
//     if (!scene) return;
//     const s = state.get(scene) || {};
//     if (s.io) return;
//     const { video } = getSceneParts(scene) || {};
//     if (!video) return;

//     const io = new IntersectionObserver(
//       async (entries) => {
//         for (const e of entries) {
//           if (e.target !== scene) continue;
//           if (e.isIntersecting) {
//             await readyScene(scene);
//           } else {
//             pauseScene(scene);
//           }
//         }
//       },
//       { threshold: 0.35 }
//     );

//     io.observe(scene);
//     s.io = io;
//     state.set(scene, s);
//   }

//   function detachIO(scene) {
//     const s = state.get(scene);
//     if (s?.io) {
//       s.io.disconnect();
//       s.io = null;
//     }
//   }

//   document.addEventListener("visibilitychange", () => {
//     const active = mq.matches ? mScene : dScene;
//     const inactive = mq.matches ? dScene : mScene;
//     if (document.hidden) {
//       pauseScene(active);
//       pauseScene(inactive);
//     }
//   });

//   function syncActiveScene() {
//     const useMobile = mq.matches;
//     const active = useMobile ? mScene : dScene;
//     const inactive = useMobile ? dScene : mScene;

//     if (inactive) {
//       pauseScene(inactive);
//       detachIO(inactive);
//     }
//     if (active) {
//       attachIO(active);
//     }
//   }

//   syncActiveScene();
//   mq.addEventListener("change", syncActiveScene);
// }

// /* ──────────────────────────────────────────────────────────────
//    Your existing helpers (unchanged)
//    ────────────────────────────────────────────────────────────── */

// function loopBottleRotation({ fps = 12 } = {}) {
//   const imageCount = 120;
//   const bottles = document.querySelectorAll(".jr__hero-top__bottle");
//   if (!bottles.length) return;

//   const imagePath = (i) => /uploads/images/3d/jr-dark/${i.toString().padStart(2, "0")}.webp;

//   const frames = Array.from({ length: imageCount }, (_, i) => {
//     const im = new Image();
//     im.src = imagePath(i);
//     return im;
//   });

//   let acc = 0;
//   let currentIndex = -1;
//   let pendingIdx = -1;

//   function render(idx) {
//     bottles.forEach((img) => {
//       const f = frames[idx];
//       if (f && img) img.src = f.src;
//     });
//   }

//   function rafLoop() {
//     if (pendingIdx !== -1 && pendingIdx !== currentIndex) {
//       currentIndex = pendingIdx;
//       render(currentIndex);
//     }
//     requestAnimationFrame(rafLoop);
//   }
//   requestAnimationFrame(rafLoop);

//   gsap.ticker.add(() => {
//     acc += fps * gsap.ticker.deltaRatio();
//     if (acc >= imageCount) acc = acc % imageCount;
//     const idx = acc | 0;
//     if (idx !== currentIndex) pendingIdx = idx;
//   });
// }
